import { render, staticRenderFns } from "./App.vue?vue&type=template&id=65ca8a85&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ca8a85')) {
      api.createRecord('65ca8a85', component.options)
    } else {
      api.reload('65ca8a85', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=65ca8a85&", function () {
      api.rerender('65ca8a85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Segment/App.vue"
export default component.exports